import axios,{AxiosRequestConfig} from 'axios';

export class GraphRequest {
  public static Config:AxiosRequestConfig
  public static GET(apiurl, header, fnsuccess, fnerror, fnloading) {
    GraphRequest.Config = {
      url: apiurl,
      method: 'GET',
      headers: header
    };
    fnloading(1,apiurl);
    axios(GraphRequest.Config).then(
      (res) => { fnloading(-1,apiurl); fnsuccess(res); },
      (err) => { fnloading(-1,apiurl); fnerror(err); }).catch((error) => {

      });
    //return axios.get(apiurl,{headers: header});
  }
  public static GET_BATCH_Beta(batchBody, header, fnsuccess, fnerror, fnloading) {

    const batchUrl = "https://graph.microsoft.com/beta/$batch";  

    const config = {
        url: batchUrl,
        method: "POST",
        headers: header,
        data: batchBody
    };

    fnloading(1, batchUrl);

    axios(config)
        .then(
            (res) => {
                fnloading(-1, batchUrl);
                fnsuccess(res);
            },
            (err) => {
                fnloading(-1, batchUrl);
                fnerror(err);
            }
        )
        .catch((error) => {
            fnloading(-1, batchUrl);
            fnerror(error);
        });
}
  public static POST(apiurl, header, data, fnsuccess, fnerror, fnloading) {
    GraphRequest.Config = {
      url: apiurl,
      method: 'POST',
      headers: header,
      data: data
    };
    fnloading(1,apiurl);
    axios(GraphRequest.Config).then((res) => { fnloading(-1,apiurl); fnsuccess(res); },
      (err) => { fnloading(-1,apiurl); fnerror(err); }).catch((error) => {

      });
    //return axios.post(apiurl,data,{headers: header});
  }
  public static Patch(apiurl, header, data, fnsuccess, fnerror, fnloading,etag=null) {
   
    GraphRequest.Config = {
      url: apiurl,
      method: 'PATCH',
      headers: header,
      data: data
    };
    if (etag != null) {
      GraphRequest.Config.headers["If-Match"] = etag;
      GraphRequest.Config.headers["Prefer"] = "return=representation";
  }
    fnloading(1,apiurl);
    axios(GraphRequest.Config).then((res) => { fnloading(-1,apiurl); fnsuccess(res); },
      (err) => { fnloading(-1,apiurl); fnerror(err); }).catch((error) => {

      });
    //return axios.post(apiurl,data,{headers: header});
  }
  public static Delete(apiurl,header,fnsuccess, fnerror, fnloading){
    GraphRequest.Config = {
      url: apiurl,
      method: 'DELETE',
      headers: header
    };
    fnloading(1,apiurl);
    axios(GraphRequest.Config).then((res) => { fnloading(-1,apiurl); fnsuccess(res); },
      (err) => { fnloading(-1,apiurl); fnerror(err); }).catch((error) => {

      });
  }
  public static async GetItemsByGraph(apiURL, datalist, headers, fnloading) {
    try{
      GraphRequest.Config = {
            url: apiURL,
            method: 'GET',
            headers: headers
          };
          fnloading(1,apiURL);
          const res = await axios(GraphRequest.Config);
          fnloading(-1,apiURL);
          if (res.data.value && res.data.value.length > 0) {
            let newTasks = res.data.value;
            if (newTasks && newTasks.length > 0) {
              datalist = datalist.concat(newTasks);
            }
            if (res.data["@odata.nextLink"] && res.data["@odata.nextLink"] != '') {
              return this.GetItemsByGraph(res.data["@odata.nextLink"], datalist, headers, fnloading);
            }
          }
    }
    catch(error){
      console.log(error);
    }
    
    return datalist;
  }
  public static async GetPlannerBuckets(apiURL, headers, fnloading) {
    /*return new Promise((resolve, reject) => {
      let Config ={
        url: apiURL,
        method: 'GET',        
        headers: headers,
        async:false        
      };
      let datalist=[];
      axios(Config).then(res => {
        if(res.data.value && res.data.value.length>0){
          let newbuckets=res.data.value;    
          if(newbuckets && newbuckets.length>0){
            datalist=datalist.concat(newbuckets);
          }
        }
        return resolve(datalist)
      })
      .catch(error => {
        return reject(error.message)
      })        
    });*/
    GraphRequest.Config = {
      url: apiURL,
      method: 'GET',
      headers: headers,
      //async: false
    };
    let datalist = [];
    fnloading(1,apiURL);
    const res = await axios(GraphRequest.Config);
    fnloading(-1,apiURL);
    if (res.data.value && res.data.value.length > 0) {
      let newbuckets = res.data.value;
      if (newbuckets && newbuckets.length > 0) {
        datalist = datalist.concat(newbuckets);
      }
    }
    return datalist;
  }
  public static async GetMyTasks(apiURL, datalist, headers, from, to, fnloading) {
    GraphRequest.Config = {
      url: apiURL,
      method: 'GET',
      headers: headers
    };
    fnloading(1,apiURL);
    const res = await axios(GraphRequest.Config);
    fnloading(-1,apiURL);
    if (res.data.value && res.data.value.length > 0) {
      //let newTasks=res.data.value;          
      //let newTasks=res.data.value.filter(task => task.dueDateTime!=null && task.percentComplete!=100 && new Date(task.dueDateTime.substr(0,10))>=from && new Date(task.dueDateTime.substr(0,10))<=to);
      let newTasks =res.data.value.filter(task => task.dueDateTime == null && task.percentComplete != 100 );
       newTasks =newTasks.concat( res.data.value.filter(task => task.dueDateTime != null && task.percentComplete != 100 && new Date(task.dueDateTime.substr(0, 10)) <= to));
      
      if (newTasks && newTasks.length > 0) {
        datalist = datalist.concat(newTasks);
      }
      if (res.data["@odata.nextLink"] && res.data["@odata.nextLink"] != '') {
        return await this.GetMyTasks(res.data["@odata.nextLink"], datalist, headers, from, to, fnloading);
      }
    }
    return await datalist;
  }
  public static async GetPlanById(apiURL, headers) {
    
    GraphRequest.Config = {
      url: apiURL,
      method: 'GET',
      headers: headers
    };    
    const res = await axios(GraphRequest.Config);
    let plan=await res.data;
    return plan;
  }
  public static async GetMailboxSetting(headers) {
    let apiURL='https://graph.microsoft.com/v1.0/me/mailboxSettings';
    GraphRequest.Config = {
      url: apiURL,
      method: 'GET',
      headers: headers, 
      //async: false
    };
    let timezonename='';
    
    const res = await axios(GraphRequest.Config);
    if(res!=null){
       timezonename=res.data.timeZone;
    }
   
    return timezonename;
  }
  /*public static async GetMyEvents(apiURL,datalist,headers){ 
      let Config ={
        url: apiURL,
        method: 'GET',        
        headers: headers        
      };
    const res = await axios(Config);
    if(res.data.value && res.data.value.length>0){
      //let newTasks=res.data.value;
      let newTasks=res.data.value;
      if(newTasks && newTasks.length>0){
        datalist=datalist.concat(newTasks);
      }
      if(res.data["@odata.nextLink"] && res.data["@odata.nextLink"]!=''){
        return await this.GetMyEvents(res.data["@odata.nextLink"],datalist,headers);
      }
    }
    return await datalist;
  }*/
/*
  public exchangeForToken = (tid: string, token: string, scopes: string[]): Promise<string> => {
    return new Promise((resolve, reject) => {
        const url = `https://login.microsoftonline.com/${tid}/oauth2/v2.0/token`;
        const params = {
            client_id: 'process.env.SSODEMO_APP_ID',
            client_secret: 'process.env.SSODEMO_APP_SECRET',
            grant_type: "urn:ietf:params:oauth:grant-type:jwt-bearer",
            assertion: token,
            requested_token_use: "on_behalf_of",
            scope: scopes.join(" ")
        };

        Axios.post(url,
            qs.stringify(params), {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(result => {
            if (result.status !== 200) {
                reject(result);
            } else {
                resolve(result.data.access_token);
            }
        }).catch(err => {
            // error code 400 likely means you have not done an admin consent on the app
            reject(err);
        });
    });
};
*/
}